import React from 'react';
import { Select, MenuItem, FormControl, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const EditModeDropdown = ({ field, value, onChange, allowClear = true }) => {
  const options = [
    { label: 'Add to existing', value: 'append' },
    { label: 'Replace all with', value: 'replace' },
    { label: 'Find and remove these', value: 'remove' },
  ];

  if (allowClear) {
    options.push({ label: 'Clear field', value: 'clear' });
  }

  return (
    <FormControl size="small" sx={{ minWidth: 220 }}>
      <Select
        value={value || ''}
        onChange={(e) => onChange(field, e.target.value)}
        IconComponent={KeyboardArrowDownIcon}
        displayEmpty
        renderValue={(selected) => {
          if (!selected) {
            return (
              <Typography sx={{ color: '#999' }}>
                Select edit mode
              </Typography>
            );
          }
          return options.find((opt) => opt.value === selected)?.label;
        }}
        sx={{ '& .MuiSelect-select': { py: 1 } }}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default EditModeDropdown;

export const allowClearForField = (fieldName) => fieldName !== 'testSuites';
